export const businessConfig = {
  businessName: 'Mujer Virtuosa',
  socialName: 'Mujervirtuosa.studio',
  founderName: 'Poleth',
  foundedYear: 2024,
  tagline: 'Belleza, dedicación y un momento pensado para ti.',
  instagramHandle: '@mujervirtuosa.studio',
  instagramUrl: 'https://www.instagram.com/mujervirtuosa.studio/',

  // TODO — CONFIRMAR CON CLIENTE antes de publicar los campos vacíos.
  whatsappNumber: '56954381577',
  address: 'Parque Boscoso 2352',
  district: 'Puente Alto, Región Metropolitana',
  googleMapsUrl: 'https://maps.app.goo.gl/q4aBjBQzViLhxgNy6',
  googleMapsEmbedUrl: 'https://www.google.com/maps?q=-33.5881793,-70.5518246&z=16&output=embed',
  canonicalUrl: '',

  currency: 'CLP',
  locale: 'es-CL',
  openingHours: {
    mondayToSaturday: '08:00–22:00',
    sunday: 'Cerrado',
  },
  consultationDisclaimer:
    'Esta solicitud no confirma una reserva. Poleth revisará la disponibilidad y te responderá por WhatsApp.',
  assets: {
    // Se completarán únicamente con archivos reales de la marca.
    logo: '/assets/brand/logo-mujer-virtuosa-header.png',
    heroImage: '/assets/brand/hero-manicure-v1.png',
    founderImage: '/assets/brand/poleth-founder-portrait-v2.png',
  },
};

export const navigationLinks = [
  { id: 'inicio', label: 'Inicio' },
  { id: 'historia', label: 'Nuestra esencia' },
  { id: 'galeria', label: 'Galería' },
  { id: 'servicios', label: 'Servicios' },
  { id: 'ubicacion', label: 'Ubicación' },
  { id: 'poleth', label: 'Fundadora' },
];
